import * as TimeUtils from '~/utils/time_utils.js';

const computeShowSeconds = (showSeconds) => {
  if (typeof showSeconds === 'string') {
    return showSeconds;
  }
  if (showSeconds === true) {
    return 'always';
  }
  if (showSeconds === false) {
    return 'never';
  }

  return 'auto';
};

export default {
  formatDate(date) {
    return TimeUtils.formatDate(TimeUtils.parseInternalDate(date));
  },
  formatDateWithZone(date) {
    return TimeUtils.formatDate(moment.parseZone(date));
  },
  formatTime(time, showSeconds) {
    showSeconds = computeShowSeconds(showSeconds);

    return TimeUtils.formatTime(TimeUtils.parseInternalDatetime(time), { showSeconds });
  },
  formatTimeWithZone(time, showSeconds) {
    showSeconds = computeShowSeconds(showSeconds);

    return TimeUtils.formatTime(moment.parseZone(time), { showSeconds });
  },
  formatDuration(duration, showSeconds, blank, alwaysShowSign = false, roundSeconds = false) {
    duration = parseInt(duration);
    showSeconds = computeShowSeconds(showSeconds);

    if (isNaN(duration)) {
      duration = 0;
    }

    return TimeUtils.formatDuration(duration, { showSeconds, blank, alwaysShowSign, roundSeconds });
  },
  formatDatetimeRange(startTime, stopTime, showSeconds) {
    showSeconds = computeShowSeconds(showSeconds);

    return TimeUtils.formatDatetimeRange(
      TimeUtils.parseInternalDate(startTime),
      TimeUtils.parseInternalDate(stopTime),
      { showSeconds },
    );
  },
  formatDatetimeRangeWithZone(startTime, stopTime, showSeconds, dedupDate) {
    showSeconds = computeShowSeconds(showSeconds);

    return TimeUtils.formatDatetimeRange(moment.parseZone(startTime), moment.parseZone(stopTime), {
      showSeconds,
      dedupDate,
    });
  },
  formatDateTime(dateTime, showSeconds = false) {
    showSeconds = computeShowSeconds(showSeconds);

    return TimeUtils.formatDatetime(TimeUtils.parseInternalDatetime(dateTime), { showSeconds });
  },
  formatTimeRange(startsAt, stopsAt) {
    const startTime = TimeUtils.formatTime(startsAt);
    const stopTime = TimeUtils.formatTime(stopsAt);

    return `${startTime} - ${stopTime}`;
  },
  formatTimeRangeNoSeconds(startsAt, stopsAt) {
    const startTime = TimeUtils.formatTime(startsAt, { showSeconds: 'never' });
    const stopTime = TimeUtils.formatTime(stopsAt, { showSeconds: 'never' });

    return `${startTime} - ${stopTime}`;
  },
  formatTimeWithZoneFromNow(time) {
    return moment.parseZone(time).fromNow();
  },
  formatDateRange(startDate, endDate, dedup = false) {
    startDate = TimeUtils.formatDate(TimeUtils.parseInternalDate(startDate));
    endDate = TimeUtils.formatDate(TimeUtils.parseInternalDate(endDate));
    if (dedup && startDate === endDate) {
      return startDate;
    }

    return `${startDate} - ${endDate}`;
  },
};
